module.exports = __webpack_public_path__ + "static/media/add.4e1d5859.svg";